import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight } = FiIcons;

export default function Header() {
  return (
    <header className="site-header">
      <a className="brand" href="#inicio" aria-label="Ir al inicio">
        <span className="brand-mark">M<span>.</span></span>
        <span className="brand-label">ESCUELA DE<br />LIDERAZGO</span>
      </a>
      <nav aria-label="Navegación principal">
        <a href="#experiencia">EL EVENTO</a>
        <a href="#agenda">AGENDA</a>
        <a href="#sedes">SEDES</a>
      </nav>
      <a className="header-cta" href="#boletos">ASEGURA TU LUGAR <SafeIcon icon={FiArrowUpRight} /></a>
    </header>
  );
}